<script>
  // ══════════════════════════════════════════════════════════════════════════
  // СЕРВИС: Обращения · Настройки — перенос service.tsx 1:1.
  // «Обращения» — экран ИГРОКА (своя переписка с поддержкой), админский разбор
  // остаётся в админ-панели. Настройки: группы геймода + аккаунт + бинды.
  // ══════════════════════════════════════════════════════════════════════════
  import { t } from '../../i18n.js';
  import { num } from '../partsfn.js';
  import Ico from '../ico.svelte';
  import Empty from '../empty.svelte';
  import Scroll from '../ui/scroll.svelte';
  import Sechead from '../ui/sechead.svelte';
  import Panel from '../ui/panel.svelte';
  import Chip from '../ui/chip.svelte';
  import GoldBtn from '../ui/goldbtn.svelte';
  import GhostBtn from '../ui/ghostbtn.svelte';
  import SlotTabs from '../ui/slottabs.svelte';
  import Input from '../ui/input.svelte';
  import Toggle from '../ui/toggle.svelte';
  import Seg from '../ui/seg.svelte';

  export let part = 'reports';
  export let reports = [];
  export let groups = [];
  export let binds = [];
  export let lang = 'ru';
  export let onLang = () => {};
  export let nui = () => {};

  // ── Обращения
  const R_STATUS = {
    open: { key: 'm.rp.open', tone: 'gold' },
    taken: { key: 'm.rp.taken', tone: 'gold' },
    closed: { key: 'm.rp.closed', tone: 'pos' },
  };
  let sel = 0;
  let text = '';
  // Новое обращение пишется прямо здесь: раньше кнопка дёргала сервер без текста.
  let draft = '';
  let writing = false;
  $: r = reports[sel];

  const send = () => {
    const v = text.trim();
    if (!v || !r) return;
    nui('reportSend', { id: r.id, text: v });
    text = '';
  };
  const create = () => {
    const v = draft.trim();
    if (v.length < 5) return;        // «привет» админам не нужно — просим суть
    nui('reportNew', { text: v });
    draft = '';
    writing = false;
  };

  // ── Настройки
  const BIND_CATS = [
    { id: 'all', key: 'm.se.cat.all', icon: 'keyboard' },
    { id: 'vehicle', key: 'm.se.cat.vehicle', icon: 'vehicles' },
    { id: 'fast', key: 'm.se.cat.fast', icon: 'bolt' },
    { id: 'fraction', key: 'm.se.cat.fraction', icon: 'shield' },
    { id: 'other', key: 'm.se.cat.other', icon: 'menu' },
  ];
  const GROUP_ICO = { main: 'overview', hud: 'monitor', chat: 'message', sound: 'volume', crosshair: 'target' };

  let tab = 'main';
  let local = [];
  let bindCat = 'all';
  let email = '';

  // Правки держим локально и отправляем по одной — геймод сохраняет весь конфиг
  // при закрытии меню, дребезг на каждое движение слайдера не нужен.
  let _g = null;
  $: if (groups !== _g) { _g = groups; local = groups; if (!local.find((g) => g.id === tab) && tab !== 'account' && tab !== 'binds') tab = local[0]?.id ?? 'main'; }

  const patch = (gid, key, v) => {
    local = local.map((g) => g.id !== gid ? g : { ...g, items: g.items.map((s) => (s.key === key ? { ...s, ...v } : s)) });
    nui('settingSet', { key, ...v });
  };

  $: tabs = [
    ...local.map((g) => ({ id: g.id, label: t(g.title), icon: GROUP_ICO[g.id] || 'settings', n: g.items.length })),
    { id: 'account', label: t('m.se.account'), icon: 'overview' },
    { id: 'binds', label: t('m.se.binds'), icon: 'keyboard', n: binds.length },
  ];
  $: group = local.find((g) => g.id === tab);
  $: catBinds = binds.filter((b) => b.cat === bindCat);
</script>

{#if part === 'reports'}
  <div class="mn-fill">
    <div class="head">
      <Sechead kicker={t('m.rp.kicker')} title={t('m.rp.title')}>
        <svelte:fragment slot="meta"><b>{reports.filter((x) => x.status !== 'closed').length}</b> {t('m.rp.open').toLowerCase()}</svelte:fragment>
      </Sechead>
    </div>
    {#if reports.length === 0}
      <Panel>
        <Empty icon="reports" text={t('m.rp.none')} />
        {#if writing}
          <div style="margin-top:10px">
            <Input placeholder={t('m.rp.placeholder')} value={draft} onInput={(v) => (draft = v)} onEnter={create} />
            <div class="ui-row" style="margin-top:8px">
              <GoldBtn size="sm" on:click={create}><Ico n="send" s={15} />{t('m.rp.send')}</GoldBtn>
              <GhostBtn size="sm" on:click={() => { writing = false; draft = ''; }}>{t('common.cancel')}</GhostBtn>
            </div>
          </div>
        {:else}
          <div style="display:flex;justify-content:center">
            <GoldBtn size="sm" on:click={() => (writing = true)}><Ico n="plus" s={15} />{t('m.rp.new')}</GoldBtn>
          </div>
        {/if}
      </Panel>
    {:else}
      <div class="mn-split grow">
        <div class="l">
          {#each reports as item, i (item.id)}
            {@const s = R_STATUS[item.status] ?? R_STATUS.open}
            <div class={'mn-tick' + (i === sel ? ' on' : '')} style="margin-bottom:8px" on:click={() => (sel = i)}>
              <div class="th">
                <span class="id">#{item.id}</span>
                <Chip tone={s.tone} style="margin-left:auto">{t(s.key)}</Chip>
              </div>
              <div class="tx">{item.text}</div>
            </div>
          {/each}
          <div style="margin-top:4px">
            {#if writing}
              <div style="margin-top:10px">
                <Input placeholder={t('m.rp.placeholder')} value={draft} onInput={(v) => (draft = v)} onEnter={create} />
                <div class="ui-row" style="margin-top:8px">
                  <GoldBtn size="sm" on:click={create}><Ico n="send" s={15} />{t('m.rp.send')}</GoldBtn>
                  <GhostBtn size="sm" on:click={() => { writing = false; draft = ''; }}>{t('common.cancel')}</GhostBtn>
                </div>
              </div>
            {:else}
              <GhostBtn block size="sm" on:click={() => (writing = true)}><Ico n="plus" s={15} />{t('m.rp.new')}</GhostBtn>
            {/if}
          </div>
        </div>

        <div class="r">
          {#if !r}
            <Panel class="mn-tall"><Empty icon="reports" text={t('m.rp.pick')} /></Panel>
          {:else}
            <Panel class="mn-tall">
              <Sechead kicker={r.author} title={'#' + r.id}>
                <svelte:fragment slot="meta"><Chip tone={(R_STATUS[r.status] ?? R_STATUS.open).tone}>{t((R_STATUS[r.status] ?? R_STATUS.open).key)}</Chip></svelte:fragment>
              </Sechead>
              <div class="mn-chat">
                {#each r.messages ?? [] as m, i (i)}
                  <div class={'mn-msg' + (m.mine ? ' mine' : '')}>
                    <span class="who">{m.author}</span>
                    {m.text}
                  </div>
                {/each}
              </div>
              {#if r.status !== 'closed'}
                <div class="ui-row mn-acts" style="flex-direction:row;align-items:flex-end">
                  <div class="ui-grow">
                    <Input placeholder={t('m.rp.write')} value={text} onInput={(v) => (text = v)} onEnter={send} />
                  </div>
                  <GoldBtn size="sm" on:click={send}><Ico n="send" s={15} />{t('m.rp.send')}</GoldBtn>
                </div>
              {/if}
            </Panel>
          {/if}
        </div>
      </div>
    {/if}
  </div>

{:else}
  <Scroll>
    <Sechead kicker={t('m.se.kicker')} title={t('m.se.title')}>
      <svelte:fragment slot="meta">
        <GhostBtn size="sm" on:click={() => nui('settingsReset')}><Ico n="reset" s={15} />{t('m.se.reset')}</GhostBtn>
      </svelte:fragment>
    </Sechead>
    <SlotTabs items={tabs} active={tab} onChange={(id) => (tab = id)} />

    {#if group}
      <Panel class="mn-narrow">
        {#each group.items as s (s.key)}
          <!-- одна строка настройки: подпись слева, контрол справа -->
          <div class="mn-set">
            <div class="txt">
              <div class="tt">{s.title}</div>
              {#if s.desc}<div class="dd">{s.desc}</div>{/if}
            </div>
            <div class="ctl">
              {#if s.kind === 'toggle'}
                <Toggle on={!!s.toggled} onChange={(v) => patch(group.id, s.key, { toggled: v })} />
              {:else if s.kind === 'slider'}
                <input
                  class="mn-range" type="range"
                  min={s.min ?? 0} max={s.max ?? 100} value={s.value ?? 0}
                  on:input={(e) => patch(group.id, s.key, { value: Number(e.currentTarget.value) })}
                />
                <span class="val">{num(s.value)}</span>
              {:else if s.kind === 'select'}
                <select
                  class="mn-select" value={s.selectId ?? 0}
                  on:change={(e) => patch(group.id, s.key, { selectId: Number(e.currentTarget.value) })}
                >
                  {#each s.list ?? [] as o, i (i)}<option value={i}>{o}</option>{/each}
                </select>
              {/if}
            </div>
          </div>
        {/each}
      </Panel>
    {/if}

    {#if tab === 'account'}
      <Panel class="mn-narrow">
        <!-- Язык интерфейса живёт ТОЛЬКО здесь — в рельсе меню дубля больше нет. -->
        <div class="mn-set">
          <div class="txt">
            <div class="tt">{t('m.se.language')}</div>
            <div class="dd">{t('m.se.langHint')}</div>
          </div>
          <div class="ctl">
            <Seg options={[{ id: 'ru', label: 'RU' }, { id: 'en', label: 'EN' }]} value={lang} onChange={onLang} />
          </div>
        </div>
        <div class="mn-set">
          <div class="txt">
            <div class="tt">{t('m.se.session')}</div>
            <div class="dd">{t('m.se.sessionHint')}</div>
          </div>
          <div class="ctl"><Toggle on onChange={() => nui('sessionToggle')} /></div>
        </div>
        <div class="mn-set">
          <div class="txt">
            <div class="tt">{t('m.se.email')}</div>
            <div class="dd">{t('m.se.emailHint')}</div>
          </div>
          <div class="ctl" style="width:320px">
            <Input placeholder="you@example.com" value={email} onInput={(v) => (email = v)} />
            <GhostBtn size="sm" on:click={() => nui('emailConfirm', { email })}>{t('common.save')}</GhostBtn>
          </div>
        </div>
      </Panel>
    {/if}

    {#if tab === 'binds'}
      <div class="hint" style="margin-bottom:var(--mn-gap)">{t('m.se.bindHint')}</div>
      <SlotTabs
        items={BIND_CATS.map((c) => ({ id: c.id, label: t(c.key), icon: c.icon, n: binds.filter((b) => b.cat === c.id).length }))}
        active={bindCat} onChange={(id) => (bindCat = id)}
      />
      <Panel class="mn-narrow">
        {#if catBinds.length === 0}
          <Empty icon="keyboard" text={t('m.empty')} />
        {:else}
          {#each catBinds as b (b.index)}
            <div class="mn-set">
              <div class="txt"><div class="tt">{b.title}</div></div>
              <div class="ctl">
                <div class="mn-key" on:click={() => nui('bindUpdate', { index: b.index })}>{b.name || '—'}</div>
              </div>
            </div>
          {/each}
        {/if}
      </Panel>
    {/if}
  </Scroll>
{/if}
